/* ============================================================
   PIROSTARFX EVENTOS — animação ao rolar e vídeo do topo
   Sem dependências. Carregado por layout/theme.liquid.
   ============================================================ */
(function () {
  "use strict";

  var reduzir = window.matchMedia("(prefers-reduced-motion: reduce)").matches;

  /* ---- 1. Elementos que aparecem ao rolar -------------------- */

  function animar() {
    var alvos = document.querySelectorAll(".pfx-anima");
    if (!alvos.length) return;

    if (reduzir || !("IntersectionObserver" in window)) {
      for (var i = 0; i < alvos.length; i++) alvos[i].classList.add("pfx-visivel");
      return;
    }

    var observador = new IntersectionObserver(
      function (entradas) {
        entradas.forEach(function (e) {
          if (!e.isIntersecting) return;
          e.target.classList.add("pfx-visivel");
          observador.unobserve(e.target);
        });
      },
      { rootMargin: "0px 0px -8% 0px", threshold: 0.08 },
    );

    alvos.forEach(function (el, i) {
      // escalonamento: cada cartão da mesma fila entra um pouco depois
      if (!el.style.getPropertyValue("--pfx-atraso")) {
        el.style.setProperty("--pfx-atraso", (i % 4) * 90 + "ms");
      }
      observador.observe(el);
    });
  }

  /* ---- 2. Vídeo do topo: PC em ecrã grande, vertical no telemóvel ---- */

  function hero() {
    var heroes = document.querySelectorAll("[data-pfx-hero]");
    heroes.forEach(function (hero) {
      var video = hero.querySelector("video");
      if (!video) return;
      var fonte = video.querySelector("source");
      var urlPc = video.getAttribute("data-fonte-pc");
      var urlTel = video.getAttribute("data-fonte-tel");
      if (!fonte || !urlPc) return;

      var mq = window.matchMedia("(max-width: 749px)");
      function trocar() {
        var alvo = mq.matches && urlTel ? urlTel : urlPc;
        if (fonte.getAttribute("src") === alvo) return;
        fonte.setAttribute("src", alvo);
        video.load();
        var p = video.play();
        if (p && p.catch) p.catch(function () {});
      }
      trocar();
      if (mq.addEventListener) mq.addEventListener("change", trocar);
      else if (mq.addListener) mq.addListener(trocar);

      // respeitar quem pediu menos movimento: fica o poster
      if (reduzir) {
        video.removeAttribute("autoplay");
        video.pause();
      }
    });
  }

  /* ---- 3. Medidor do P.M.A no carrinho ----------------------- */

  function medidor() {
    var caixa = document.querySelector("[data-pfx-medidor]");
    if (!caixa) return;
    var barra = caixa.querySelector(".pfx-medidor__cheio");
    var texto = caixa.querySelector("[data-pfx-medidor-txt]");
    var limite = parseFloat(caixa.getAttribute("data-limite")) || 5000;
    var total = parseFloat(caixa.getAttribute("data-total")) || 0;
    if (barra) barra.style.width = Math.min(100, (total / limite) * 100) + "%";
    if (texto) {
      texto.textContent = (total / 1000).toFixed(2).replace(".", ",") + " kg de " + (limite / 1000).toFixed(0) + " kg";
    }
  }

  function iniciar() {
    animar();
    hero();
    medidor();
  }

  if (document.readyState === "loading") document.addEventListener("DOMContentLoaded", iniciar);
  else iniciar();

  // o Dawn redesenha partes da página (filtros, carrinho) sem recarregar
  document.addEventListener("shopify:section:load", iniciar);
  document.addEventListener("cart:updated", iniciar);
})();
